module.exports = __webpack_public_path__ + "img/02012862000402.f44b13d7.png";